import { render, staticRenderFns } from "./firebase_register_component.vue?vue&type=template&id=134cf302&scoped=true&"
import script from "./firebase_register_component.vue?vue&type=script&lang=js&"
export * from "./firebase_register_component.vue?vue&type=script&lang=js&"
import style0 from "./firebase_register_component.vue?vue&type=style&index=0&id=134cf302&scoped=true&lang=css&"
import style1 from "./firebase_register_component.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134cf302",
  null
  
)

export default component.exports